'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'
import { useMutation } from '@tanstack/react-query'
import useApiClient from '@/lib/apis/clients/useApiClient'
import { RecordProviderActivity } from '@/lib/apis/authentication'
import {
  createProviderActivityReporter,
  hasProviderRole,
} from '@/lib/auth/provider-session'

export default function ProviderSessionActivity() {
  const { data: session } = useSession()
  const api = useApiClient()
  const { mutate } = useMutation({
    ...RecordProviderActivity.mutation(api),
    retry: false,
  })
  const enabled = hasProviderRole(session?.user?.roles)
  const sessionId = session?.providerSessionId

  useEffect(() => {
    if (!enabled || !sessionId) return
    const report = createProviderActivityReporter(() => mutate())
    const onInput = (event: Event) =>
      report(event, document.visibilityState === 'visible')
    const events = [
      'pointerdown',
      'pointermove',
      'keydown',
      'wheel',
      'touchstart',
    ]
    for (const event of events)
      window.addEventListener(event, onInput, { passive: true })
    return () => {
      for (const event of events) window.removeEventListener(event, onInput)
    }
  }, [enabled, sessionId, mutate])

  return null
}
